<template>
  <div class="wrap">
    <top class="head" @showpassword="showpassword"></top>
    <div class="container">
      <menuview></menuview>
      <div class="main_wrap" :style="{width:bodywidth}">
        <router-view/>
        <div class="homeHeight" :style="{width:bodywidth}"></div>
      </div>
    </div>
    <passWord :visible.sync="dialogVisible"></passWord>
  </div>
</template>
<script>
import passWord from "@/components/dialog/enterprisePasswordDialog.vue";
import menuview from "@/components/menu.vue";
import top from "@/components/top.vue";
export default {
  name: "home",
  components: {
    menuview,
    top,
    passWord
  },
  data() {
    return {
      dialogVisible:false,
      bodywidth: 0
    };
  },
   created() {
    //本地测试新菜单，为了方便设置一个session  menu1=1，根据这个值判断页面跳转是要
     if(sessionStorage.getItem("menu1")){
       sessionStorage.removeItem("menu1")
     }else{
       console.log('旧菜单样式')
     }


  },
  methods: {
    showpassword() {
      this.dialogVisible = true
    }
  }
};
</script>
